import { render } from "./PerformanceGrid.vue?vue&type=template&id=137ef478&scoped=true&lang=pug"
import script from "./PerformanceGrid.vue?vue&type=script&lang=js"
export * from "./PerformanceGrid.vue?vue&type=script&lang=js"

import "./PerformanceGrid.vue?vue&type=style&index=0&id=137ef478&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ef478"]])

export default __exports__